export const LOCATION = {
  POSITION: "position",
  COUNTRY: "country",
  IP_URL: "https://extreme-ip-lookup.com/json/?key=M4oBrTXmW6F0K3IsJ4ku",
  DEFAULT_CENTER: { lat: -31.949623, lng: 115.858961 }
};
